import { useEffect, useRef } from 'react';
import { game, PLAYER } from '../game/controller';
import { useGame } from '../game/store';

/** Isometric map of the rooms you've explored and your path. The rival is never shown. */
export function MiniCube() {
  const canvas = useRef<HTMLCanvasElement>(null);
  const version = useGame((s) => s.sceneVersion);
  const facing = useGame((s) => s.facing);

  useEffect(() => {
    const el = canvas.current;
    const m = game.match;
    if (!el || !m) return;
    const g = el.getContext('2d')!;
    const k = 15;
    const iso = (x: number, y: number, z: number): [number, number] => [180 + (x - z) * 0.866 * k, 170 + (x + z) * 0.5 * k - y * k];
    g.clearRect(0, 0, el.width, el.height);
    const n = m.maze.size - 0.5;
    const c: [number, number, number][] = [
      [-0.5, -0.5, -0.5], [n, -0.5, -0.5], [-0.5, n, -0.5], [-0.5, -0.5, n],
      [n, n, -0.5], [n, -0.5, n], [-0.5, n, n], [n, n, n],
    ];
    const edges = [[0, 1], [0, 2], [0, 3], [1, 4], [1, 5], [2, 4], [2, 6], [3, 5], [3, 6], [4, 7], [5, 7], [6, 7]];
    g.strokeStyle = '#3A3F47';
    g.lineWidth = 1.5;
    for (const [a, b] of edges) {
      const p = iso(...c[a!]!);
      const q = iso(...c[b!]!);
      g.beginPath();
      g.moveTo(p[0], p[1]);
      g.lineTo(q[0], q[1]);
      g.stroke();
    }
    g.strokeStyle = 'rgba(255,176,0,.55)';
    g.lineWidth = 2;
    g.beginPath();
    game.path.forEach((room, i) => {
      const [x, y, z] = m.maze.coords(room);
      const p = iso(x, y, z);
      if (i) g.lineTo(p[0], p[1]);
      else g.moveTo(p[0], p[1]);
    });
    g.stroke();
    g.fillStyle = '#949AA3';
    for (const room of game.explored) {
      const [x, y, z] = m.maze.coords(room);
      const p = iso(x, y, z);
      g.fillRect(p[0] - 2, p[1] - 2, 4, 4);
    }
    const me = m.agent(PLAYER)!;
    const [x, y, z] = m.maze.coords(me.room);
    const f = me.orientation.facing;
    const p = iso(x, y, z);
    const q = iso(x + f[0] * 1.6, y + f[1] * 1.6, z + f[2] * 1.6);
    g.strokeStyle = '#FFB000';
    g.lineWidth = 3;
    g.beginPath();
    g.moveTo(p[0], p[1]);
    g.lineTo(q[0], q[1]);
    g.stroke();
    g.fillStyle = '#FFB000';
    g.beginPath();
    g.arc(p[0], p[1], 5, 0, Math.PI * 2);
    g.fill();
  }, [version, facing]);

  return <canvas ref={canvas} className="mini" width={360} height={340} aria-label="Map of the rooms you have explored" role="img" />;
}
